import { SubscriptionTier } from '@/entities/billing/lib/billing.constants';

export type PaddleCheckoutPlanKey = 'mini' | 'standard';

export type PaddlePlan = {
  key: PaddleCheckoutPlanKey;
  name: 'Starter' | 'Pro';
  monthlyPrice: number;
  tier: SubscriptionTier;
  description: string;
};

export const PADDLE_SIGNUP_DISCOUNT = 39;

export const getPaddleFirstMonthPrice = (monthlyPrice: number): number =>
  Math.max(monthlyPrice - PADDLE_SIGNUP_DISCOUNT, 0);

export const getPaddlePlans = (): PaddlePlan[] => [
  {
    key: 'mini',
    name: 'Starter',
    monthlyPrice: 39,
    tier: SubscriptionTier.Starter,
    description:
      'For individuals and small teams getting started with AI agents.',
  },
  {
    key: 'standard',
    name: 'Pro',
    monthlyPrice: 79,
    tier: SubscriptionTier.Pro,
    description:
      'For growing teams that need more capacity, collaboration, and privacy review for uploaded documents.',
  },
];
